// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button--1Jkx7","Navigation":"Navigation--1V1Gp"};